<template>
    <div class="navigation duties" v-if="next || previous" style="width: 200px">
        <div class="d-flex justify-content-end" style="gap: 6px;">
            <a class="navigation__item modal__buttons__item" :href="previous ? `${child_href}/${previous}`: '#'" :class="{'disabled button__disabled' : !previous}" :disabled="!previousAction">
                <svg xmlns="http://www.w3.org/2000/svg" width="11.702" height="21.184" viewBox="0 0 11.702 21.184">
                    <g id="left-arrow" transform="translate(0.313 0.312)">
                        <g id="Grupo_6167" data-name="Grupo 6167" transform="translate(0 0)">
                        <path id="Trazado_3202" data-name="Trazado 3202" d="M104.207,10.275l8.935,8.934a.791.791,0,0,1-1.119,1.119l-9.494-9.493a.791.791,0,0,1,0-1.119L112.023.223a.791.791,0,0,1,1.119,1.119Z" transform="translate(-102.298 -0.001)" stroke="#fff" stroke-width="0.5"/>
                        </g>
                    </g>
                </svg>
                Previous
            </a>
            <a class="navigation__item modal__buttons__item ml-0" :href="next ? `${child_href}/${next}`: '#'" :class="{'disabled button__disabled' : !next}" :disabled="!next">
                Next
                <svg xmlns="http://www.w3.org/2000/svg" width="11.702" height="21.184" viewBox="0 0 11.702 21.184">
                    <g id="left-arrow" transform="translate(0.313 0.312)">
                        <g id="Grupo_6167" data-name="Grupo 6167" transform="translate(0 0)">
                        <path id="Trazado_3202" data-name="Trazado 3202" d="M104.207,10.275l8.935,8.934a.791.791,0,0,1-1.119,1.119l-9.494-9.493a.791.791,0,0,1,0-1.119L112.023.223a.791.791,0,0,1,1.119,1.119Z" transform="translate(-102.298 -0.001)" stroke="#fff" stroke-width="0.5"/>
                        </g>
                    </g>
                </svg>
            </a>
        </div>
        <div class="formdynamic__item__field mt-3">
            <select class="input-field custom-select" style="min-width: 100px;" v-model="jump_to">
                <option value='' v-html="'Jump to'"/>
                <option v-for="(item, i) in items" :key="i" :value="item[label_key_id]" v-html="`${item[label_key]}`"/>
            </select>
        </div>
    </div>
</template>
<script>
export default 
{
    name:   'NextPreviousButtons',
    props: [
        'id',
        'label_key',
        'label_key_id',
        'next',
        'previous',
        'items',
        'child_href'
    ],
    data() 
    {
        return {
            jump_to: ''
        }
    },

    methods: {
    },

    watch: 
    {
        async jump_to(val)
        {
            if(val)
            {
                window.location.href = `${this.child_href}/${val}`
            }
        }
    }
}
</script>
